import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-matdoctranslog',
  templateUrl: './matdoctranslog.component.html',
  styleUrls: ['./matdoctranslog.component.scss']
})
export class MatdoctranslogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
